import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import ContentBlock from '../_components/ContentBlock'

const useStyles = makeStyles<Theme, MatchAPhotoProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'MatchAPhoto' }
)

export interface MatchAPhotoProps {
  classes?: StyleClasses<typeof useStyles>
}

function MatchAPhoto(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentBlock
        img={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/match-a-photo.png'}
        title={<>Match a Photo</>}
        description={
          <>
            Capture colors from any photo and match
            <br />
            them to actual Sherwin-Williams paint colors.
          </>
        }
        linkHref="https://www.sherwin-williams.com/visualizer#/active/colors"
        linkLabel="Learn more"
        styles={{ padding: '40px' }}
      />
    </div>
  )
}

export default MatchAPhoto
